import {
    type MerchantConfig,
    ThirdPartySystemId,
    ValorThirdPartySystemId,
} from '@pillar-portal/api-types';
import { resolveValorCredentialDefaults } from './ipg/valor/valor-credential-defaults';

export type DefaultableCredentialField = 'domain' | 'channel';

export type CredentialFieldDefaults = Readonly<
    Partial<Record<DefaultableCredentialField, string>>
>;

export function resolveCredentialDefaultsBySystemId(
    systemId: ThirdPartySystemId,
    merchantConfig: MerchantConfig | undefined
): CredentialFieldDefaults {
    switch (systemId) {
        case ValorThirdPartySystemId:
            return resolveValorCredentialDefaults(merchantConfig);
        default:
            return {};
    }
}
